module.exports = __webpack_public_path__ + "img/1508279202.f4c35bdc.jpg";